const meteringHelper = {
    obtenerCookieSuscriptor: function (apiUrl, token, config) {
        var deleteMeteringCookie = function (config) {
            for (let [, value] of Object.entries(config.CookiesMetering)) {
                deleteCookieName(value);
            }
        };

        var deleteCookieName = function (name) {
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + (document.domain === 'localhost' ? "" : "; domain=" + config.dominioCookie);
        };

        var createCookie = function (name, value, seconds, domain) {
            var expires = "";
            if (seconds) {
                var date = new Date();
                date.setTime(date.getTime() + (seconds * 1000));
                expires = "; expires=" + date.toGMTString();
            }
            var cookieDomain = (document.domain === 'localhost' ? "" : "; domain=" + domain)
            document.cookie = name + "=" + value + expires + cookieDomain + "; path=/";
        };

        deleteMeteringCookie(config);
        return fetch(apiUrl, {
            method: 'GET',
            headers: { 'X-Token': token || '' }
        }).
            then(response => {
                if (response.status === 200) {
                    return response.text();
                }
                if (response.status === 500)
                    createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
                return null;
            }).
            then(data => {
                if (data) {
                    createCookie(config.CookiesMetering["metering"], data, config.cookieExpirationTime, config.dominioCookie);
                }
            }).
            catch((error) => {
                console.error('Error:', error);
                createCookie(config.CookiesMetering["serviceDown"], true, 600, config.dominioCookie);
            });
    }
};

export default meteringHelper;


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/metering-api-fetch.js